import React, { Component } from 'react';
import UI from '../ui';
import Utils from '../utils';
import RateAdvisorUtil from './RateAdvisorUtil';

const { WrappedCheckboxWithLabel } = UI;
const { Logger } = Utils;

class PackageFilter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showAllOptions: false, // false to show only the first 3 packaging options
			showOptions: true, // true to open "Packaging" tab.
			packageItems: RateAdvisorUtil.getPackageFilterItems(),
		};
	}

	// notify the parent about the filter changes
	notifyParent = packages => {
		const { onFiltersChange } = this.props;

		if (onFiltersChange) {
			onFiltersChange('packages', packages);
		}
	};

	handleShowMoreOptionsChange = () => {
		const { showAllOptions } = this.state;

		this.setState({ showAllOptions: !showAllOptions });
	};

	handleShowPackagingFilterChange = () => {
		const { showOptions } = this.state;

		this.setState({ showOptions: !showOptions });
	};

	onCheckboxSelectionChange = e => {
		const { name, checked } = e.target;
		const { rateAdvisorData } = this.props;
		const { packageItems } = this.state;
		const { packages } = rateAdvisorData;
		const nameLookup = {
			packages: 'package',
			largeEnvelopes: 'large_envelope',
			flatRateEnvelopes: 'flat_rate',
			tubes: 'tube',
			paks: 'pak',
			upsExpressBoxes: 'express_box',
			fedexOneRateBoxes: 'one_rate',
			fedexBoxes: 'fedex_box',
		};

		this.setState({
			packageItems: packageItems.map(item => {
				if (item.id === name) {
					return {
						...item,
						checked,
					};
				}

				return item;
			}),
		});

		this.notifyParent({
			...packages,
			[name]: checked,
		});

		Logger.logToServer({
			category: 'ra_filter_change',
			ui_element: nameLookup[name],
			value: checked ? 'on' : 'off',
		});
	};

	renderPackagingOptions = () => {
		const { showAllOptions, showOptions, packageItems } = this.state;

		// show only first 3 options if `showAllOptions` is false.
		const options = showAllOptions
			? [...packageItems]
			: packageItems.slice(0, 3);

		if (showOptions) {
			return (
				<>
					{options.map(option => (
						<div
							key={`filter-${option.id}`}
							className={`options-item filter-${option.id}`}
						>
							<WrappedCheckboxWithLabel
								label={option.displayName}
								showLabelAfter
								uiElementConfig={{
									dataqa: `options-checkbox-${option.id}`,
									name: `${option.id}`,
									inputId: `${option.id}`,
									onChange: this.onCheckboxSelectionChange,
									checked: option.checked,
								}}
							/>
						</div>
					))}
					<div
						className="options-button"
						onClick={this.handleShowMoreOptionsChange}
						role="button"
						{...{ dataqa: 'rate-advisor-package-filter-show-more-button' }}
						tabIndex="0"
					>
						{showAllOptions ? 'Show fewer options' : 'Show more options'}
						<i
							className={
								showAllOptions ? 'pi pi-chevron-up' : 'pi pi-chevron-down'
							}
						/>
					</div>
				</>
			);
		}

		return null;
	};

	render() {
		const { showOptions } = this.state;

		return (
			<div className="common-rate-advisor-package-filter">
				<div
					className="package-filter-title"
					onClick={this.handleShowPackagingFilterChange}
					role="button"
					tabIndex={0}
					{...{ dataqa: 'rate-advisor-packaging-header-button' }}
				>
					Packaging
					<i
						className={
							showOptions
								? 'filter-panel-expander pi pi-chevron-down'
								: 'filter-panel-expander pi pi-chevron-right'
						}
					/>
				</div>
				{this.renderPackagingOptions()}
			</div>
		);
	}
}

export default PackageFilter;
